import { createFileRoute, Link } from '@tanstack/react-router'

export const Route = createFileRoute('/_site/refund')({
  component: RefundPage,
  head: () => ({
    meta: [
      { title: 'Refund Policy — 30-Day Money-Back on Paid Plans' },
      { name: 'description', content: '30-day refund policy for Uptrack paid subscriptions. Cancel anytime, no questions asked. See how to request a refund and what to expect.' },
      { property: 'og:title', content: 'Refund Policy — 30-Day Money-Back on Paid Plans' },
      { property: 'og:description', content: '30-day refund policy for Uptrack subscriptions.' },
    ],
    links: [
      { rel: 'canonical', href: 'https://uptrack.app/refund' },
    ],
  }),
})

function RefundPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-12">
      <div className="mb-4">
        <Link to="/" className="text-sm text-muted-foreground hover:text-foreground">
          &larr; Back to home
        </Link>
      </div>
      <h1 className="mb-8 text-3xl font-semibold">Refund Policy</h1>
      <div className="prose prose-neutral dark:prose-invert max-w-none space-y-6 text-muted-foreground">
        <p className="text-sm">Last updated: February 17, 2026</p>

        <section>
          <h2 className="text-xl font-semibold text-foreground">1. Subscription Cancellation</h2>
          <p>
            You may cancel your Uptrack subscription at any time from your account settings.
            Upon cancellation, you will retain access to paid features until the end of your
            current billing period. No further charges will be made after cancellation.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground">2. Refund Eligibility</h2>
          <p>
            If you are unsatisfied with Uptrack, you may request a full refund within 30 days
            of your initial purchase or any renewal payment. Refund requests made after 30 days
            will be evaluated on a case-by-case basis.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground">3. How to Request a Refund</h2>
          <p>
            To request a refund, contact us at{' '}
            <a href="mailto:support@uptrack.app" className="text-primary hover:underline">
              support@uptrack.app
            </a>{' '}
            with your account email and the reason for your request. We aim to process all
            refund requests within 5 business days.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground">4. Refund Method</h2>
          <p>
            Approved refunds will be issued to the original payment method. Depending on your
            payment provider, it may take 5–10 business days for the refund to appear on your
            statement. All payments are processed by our merchant of record,{' '}
            <a href="https://www.paddle.com" className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">
              Paddle.com
            </a>, who handles refund processing on our behalf.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground">5. Contact</h2>
          <p>
            For billing or refund questions, contact us at{' '}
            <a href="mailto:support@uptrack.app" className="text-primary hover:underline">
              support@uptrack.app
            </a>.
          </p>
        </section>
      </div>
    </div>
  )
}
